/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OnlyFansList } from '../models/OnlyFansList';
import type { OnlyFansListResult } from '../models/OnlyFansListResult';
import type { RenameListRequest } from '../models/RenameListRequest';
import type { SetPinnedListsRequest } from '../models/SetPinnedListsRequest';
import type { UpdateListsUserRequest } from '../models/UpdateListsUserRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfListsService {
    /**
     * Add/remove a user to/from an OnlyFans user lists
     * Add/remove a user to/from an OnlyFans user lists for the specified creator.
     * @returns void
     * @throws ApiError
     */
    public static updateUserInLists({
        creatorId,
        userId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the user to add.
         */
        userId: number,
        /**
         * Lists for add/remove user to/from
         */
        requestBody: UpdateListsUserRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/of-lists/{creatorId}/users/{userId}',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Retrieve OnlyFans user lists
     * Retrieves a list of OnlyFans user lists with specified sorting and ordering.
     * @returns OnlyFansListResult Of lists
     * @throws ApiError
     */
    public static getLists({
        creatorId,
        offset,
        relatedUser,
        view = '',
        filter = '',
        query = '',
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The maximum number of lists to retrieve.
         */
        offset: number,
        /**
         * If set, will show the lists first the user is in
         */
        relatedUser?: number,
        /**
         * The view to be retrieved. Either empty or 'tiny' for just basic information like id, name and type
         */
        view?: string,
        /**
         * The filter to be applied. Either empty or 'chat'
         */
        filter?: string,
        /**
         * The query parameter for filtering
         */
        query?: string,
    }): CancelablePromise<OnlyFansListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/of-lists/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'related_user': relatedUser,
                'offset': offset,
                'view': view,
                'filter': filter,
                'query': query,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Create a new OnlyFans user list
     * Creates a new OnlyFans user list for the specified creator.
     * @returns OnlyFansList successfully created OF list
     * @throws ApiError
     */
    public static createList({
        creatorId,
        name,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The name of the new list.
         */
        name: string,
    }): CancelablePromise<OnlyFansList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v2/of-lists/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'name': name,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Set pin state of OnlyFans lists
     * Set if an OnlyFans Lists should be pinned so its visible in the chat.
     * @returns void
     * @throws ApiError
     */
    public static setPinned({
        creatorId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * lists to be updated
         */
        requestBody: SetPinnedListsRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-lists/{creatorId}/setPinned',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Set the order
     * Set the order of the lists retrieved in getLists
     * @returns void
     * @throws ApiError
     */
    public static setOrder({
        creatorId,
        sort = '',
        order = '',
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The sorting parameter (e.g., 'name', 'people', 'recent').
         */
        sort?: string,
        /**
         * The order parameter (e.g., 'desc', 'asc').
         */
        order?: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-lists/{creatorId}/setOrder',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'sort': sort,
                'order': order,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Rename a list
     * Renames a list for the specified creator.
     * @returns void
     * @throws ApiError
     */
    public static renameList({
        creatorId,
        listId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the list to rename.
         */
        listId: number,
        /**
         * The request object containing the new name of the list.
         */
        requestBody: RenameListRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/of-lists/{creatorId}/lists/{listId}/rename',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Delete an OnlyFans user list
     * Deletes an existing OnlyFans user list for the specified creator.
     * @returns void
     * @throws ApiError
     */
    public static deleteList({
        creatorId,
        listId,
    }: {
        /**
         * The ID of the creator.
         */
        creatorId: number,
        /**
         * The ID of the list to delete.
         */
        listId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-lists/{creatorId}/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
}
